import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined)?.trim() ?? '';
export const supabaseAnonKey =
  (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined)?.trim() ?? '';

export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null;
